const config = {
  github: {
    username: 'SteinsHead',
    repository: 'blog',
    token: ['ghp_L5czx6DXhT72ogtj', '05ckhAjVhU0sn01bCvTA'],
  },
  leancloud: {
    appId: 'LjOwR4ELEqbauKvtQbwq5TUw-MdYXbMMI',
    appKey: 'BOSFJ49ohbGctgn4zvJE9VN6',
    serverURL: 'https://api.chanshiyu.com',
  },
  contact: {
    github: 'https://github.com/SteinsHead',
    twitter: 'https://twitter.com/ever17_steins',
    telegram: 'https://t.me/chanshiyucx',
    email: 'mailto://me@chanshiyu.com',
    music: 'https://music.163.com/#/user/home?id=103060582',
    blog: 'https://steinsheads-organization.gitbook.io/steinshead/',
  },
  gitalk: {
    clientID: '864b1c2cbc4e4aad9ed8',
    clientSecret: '288ee5039cf42253b83b5c40cf0cf38770f3213a',
    repo: 'comment',
    owner: 'chanshiyucx',
    admin: ['chanshiyucx'],
    distractionFreeMode: false,
  },
};

export default config;
